.logos {
  display: flex;
  flex-flow: column nowrap;
  gap: var(--mantine-spacing-sm);
}

.adnoc-logo-icon {
  * {
    fill: white;
  }
}
